import React from "react";

import { useSiteData } from "../../contexts/SiteDataContext";
import Modal from "../Modal/Modal";

function ContactsModal() {
  const { siteData, setSiteData } = useSiteData();

  const close = () => {
    setSiteData({ ...siteData, isOpenContactsModal: false });
  };

  return (
    <Modal
      isOpen={!!siteData.isOpenContactsModal}
      onClose={close}
      id="contact-modal"
    >
      <div
        className="ck-content"
        dangerouslySetInnerHTML={{
          __html: siteData?.contact?.content ?? "",
        }}
      />
    </Modal>
  );
}

export default ContactsModal;
